export default __webpack_public_path__ + "static/media/61t.219501e3.jpg";